<template>
  <b-container>
    <h1>Liberações do Perfil</h1>
    <b-row>
      <b-col></b-col>
      <b-col>
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row class="mb-3 ml-0">
      <router-link :to="getUrlBackToList">
        <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
      </router-link>
    </b-row>
    <!-- {{ id }} -->
    <div class="mb-3">
      <b-row>
        <b-col cols="2"> <h4>Id:</h4> </b-col>
        <b-col cols="3">
          <h4>{{ id }}</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2"> <h4>Nome do perfil:</h4> </b-col>
        <b-col cols="3">
          <h4>{{ name }}</h4>
        </b-col>
      </b-row>
    </div>

    <b-tabs content-class="mt-3" pills vertical>
      <b-tab title="Formulários" active>
        <b-table
          ref="tableForm"
          class="table-nowrap"
          :busy.sync="isBusy"
          :items="getAllFormPermission"
          :fields="formFields"
          :filter="filterFormFields"
          :filter-debounce="500"
          :per-page="tablePerPage"
          :current-page="tableCurrentPage"
        >
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th
                v-for="field in fields"
                :key="field.key"
                class="vertical-align"
              >
                <div v-if="field.filterKey == 'isFormViewer'">
                  <b-form-select
                    class="mt-1"
                    v-model="filterFormFields[field.key]"
                    :options="options"
                  ></b-form-select>
                </div>
                <div v-else-if="field.filterKey == 'isFormEditor'">
                  <b-form-select
                    class="mt-1"
                    v-model="filterFormFields[field.key]"
                    :options="options"
                  ></b-form-select>
                </div>
                <div v-else-if="field.filterKey == 'isFormFiller'">
                  <b-form-select
                    class="mt-1"
                    v-model="filterFormFields[field.key]"
                    :options="options"
                  ></b-form-select>
                </div>
                <div v-else>
                  <b-form-input
                    v-model="filterFormFields[field.key]"
                    :placeholder="'Buscar por ' + field.label"
                  />
                </div>
              </b-th>
            </b-tr>
          </template>
          <template v-slot:cell(isFormViewer)="data">
            <save-form-profile-release
              :profileRelease="data.item"
              :profileId="id"
              :permission="'isFormViewer'"
              @show-alert-message="showAlertMesssage"
            ></save-form-profile-release>
          </template>
          <template v-slot:cell(isFormEditor)="data">
            <save-form-profile-release
              :profileRelease="data.item"
              :profileId="id"
              :permission="'isFormEditor'"
              @show-alert-message="showAlertMesssage"
            ></save-form-profile-release>
          </template>
          <template v-slot:cell(isFormFiller)="data">
            <save-form-profile-release
              :profileRelease="data.item"
              :profileId="id"
              :permission="'isFormFiller'"
              @show-alert-message="showAlertMesssage"
            ></save-form-profile-release>
          </template>
        </b-table>
        <table-pagination-props
          :currentPage.sync="tableCurrentPage"
          :pageOptions.sync="tablePageOptions"
          :perPage.sync="tablePerPage"
          :rowCount.sync="tableRowCount"
        >
        </table-pagination-props>
      </b-tab>
      <b-tab title="Pendências">
        <b-table
          ref="tableChecklist"
          class="table-nowrap"
          :busy.sync="isBusy"
          :items="getAllFieldPermission"
          :fields="pendencyFields"
          :filter="filterPendencyFields"
          :filter-debounce="500"
          :per-page="tableFieldPerPage"
          :current-page="tableFieldCurrentPage"
        >
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th
                v-for="field in fields"
                :key="field.key"
                class="vertical-align"
              >
                <div v-if="field.filterKey == 'isPendingApproval'">
                  <b-form-select
                    class="mt-1"
                    v-model="filterPendencyFields[field.key]"
                    :options="options"
                  ></b-form-select>
                </div>
                <div v-else-if="field.filterKey == 'isPendingViewer'">
                  <b-form-select
                    class="mt-1"
                    v-model="filterPendencyFields[field.key]"
                    :options="options"
                  ></b-form-select>
                </div>
                <div v-else>
                  <b-form-input
                    v-model="filterPendencyFields[field.key]"
                    :placeholder="'Buscar por ' + field.label"
                  />
                </div>
              </b-th>
            </b-tr>
          </template>
          <template v-slot:cell(isPendingApproval)="data">
            <!-- {{data.item}} -->
            <save-form-profile-release
              :profileRelease="data.item"
              :profileId="id"
              :permission="'isPendingApproval'"
              @show-alert-message="showAlertMesssage"
            ></save-form-profile-release>
          </template>
          <template v-slot:cell(isPendingViewer)="data">
            <save-form-profile-release
              :profileRelease="data.item"
              :profileId="id"
              :permission="'isPendingViewer'"
              @show-alert-message="showAlertMesssage"
            ></save-form-profile-release>
          </template>
        </b-table>
        <table-pagination-props
          :currentPage.sync="tableFieldCurrentPage"
          :pageOptions.sync="tableFieldPageOptions"
          :perPage.sync="tableFieldPerPage"
          :rowCount.sync="tableFieldRowCount"
        >
        </table-pagination-props>
      </b-tab>
      <b-tab title="Modulos">
        <b-table
          ref="table"
          class="table-nowrap"
          :busy.sync="isBusy"
          :items="getAllModulePermission"
          :fields="moduleFields"
          :filter="filterModuleFields"
          :filter-debounce="500"
          :per-page="tableModulePerPage"
          :current-page="tableModuleCurrentPage"
        >
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th
                v-for="field in fields"
                :key="field.key"
                class="vertical-align"
              >
                <div v-if="field.filterKey == 'hasAccess'">
                  <b-form-select
                    class="mt-1"
                    v-model="filterModuleFields[field.key]"
                    :options="options"
                  ></b-form-select>
                </div>
                <div v-else>
                  <b-form-input
                    v-model="filterModuleFields[field.key]"
                    :placeholder="'Buscar por ' + field.label"
                  />
                </div>
              </b-th> </b-tr
          ></template>
          <template v-slot:cell(hasAccess)="data">
            <save-form-profile-release
              :profileRelease="data.item"
              :profileId="id"
              :permission="'hasAccess'"
              @show-alert-message="showAlertMesssage"
            ></save-form-profile-release>
          </template>
        </b-table>
        <table-pagination-props
          :currentPage.sync="tableModuleCurrentPage"
          :pageOptions.sync="tableModulePageOptions"
          :perPage.sync="tableModulePerPage"
          :rowCount.sync="tableModuleRowCount"
        >
        </table-pagination-props>
      </b-tab>
    </b-tabs>
  </b-container>
</template>
<script>
export default {
  name: "ChecklistProfileRelease",
  props: {
    id: String,
    name: String,
  },
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    SaveFormProfileRelease: () =>
      import(
        "@/components_rms/System/Profile/ChecklistProfileRelease/SaveFormProfileRelease.vue"
      ),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro alterado com sucesso",
      },
      isBusy: false,
      submitted: false,
      formFields: [
        {
          key: "formName",
          filterKey: "formName",
          label: "Formulário",
        },
        {
          key: "isFormViewer",
          filterKey: "isFormViewer",
          label: "Visualizador",
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (item.isFormViewer == true) {
              return "Sim";
            }
            return "Não";
          },
        },
        {
          key: "isFormEditor",
          filterKey: "isFormEditor",
          label: "Editor ",
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (item.isFormEditor == true) {
              return "Sim";
            }
            return "Não";
          },
        },
        {
          key: "isFormFiller",
          filterKey: "isFormFiller",
          label: "Preenchedor",
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (item.isFormFiller == true) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      pendencyFields: [
        {
          key: "formName",
          filterKey: "formName",
          label: "Formulário",
        },
        {
          key: "fieldName",
          filterKey: "fieldName",
          label: "Campo",
        },
        {
          key: "isPendingApproval",
          filterKey: "isPendingApproval",
          label: "Aprovador",
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (item.isPendingApproval == true) {
              return "Sim";
            }
            return "Não";
          },
        },
        {
          key: "isPendingViewer",
          filterKey: "isPendingViewer",
          label: "Visualizador",
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (item.isPendingViewer == true) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      moduleFields: [
        {
          key: "moduleName",
          filterKey: "moduleName",
          label: "Modulo",
        },
        {
          key: "hasAccess",
          filterKey: "hasAccess",
          label: "Possui acesso",
          tdClass: "actions",
          formatter: (value, key, item) => {
            if (item.hasAccess == 1) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      filterFormFields: {
        formName: "",
        isFormViewer: "",
        isFormEditor: "",
        isFormFiller: "",
      },
      filterPendencyFields: {
        formName: "",
        fieldName: "",
        isPendingApproval: "",
        isPendingViewer: "",
      },
      filterModuleFields: {
        moduleName: "",
        hasAccess: "",
      },
      settingsShow: false,
      refreshTableForm: false,
      refreshTableChecklist: false,
      //FormPermission
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      //FieldPermission
      tableFieldRowCount: 0,
      tableFieldPerPage: 10,
      tableFieldPageOptions: [5, 10, 25, 50, 100, 150],
      tableFieldCurrentPage: 1,
      tableFieldSelectMode: "single",
      tableFieldSelectedItem: [],
      //modulos
      tableModuleRowCount: 0,
      tableModulePerPage: 10,
      tableModulePageOptions: [5, 10, 25, 50, 100, 150],
      tableModuleCurrentPage: 1,
      tableModuleSelectMode: "single",
      tableModuleSelectedItem: [],
      companyHasModules: false,
      booleanOpt: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      model: {
        formId: 0,
        formName: "",
        isFormViewer: false,
        isFormEditor: false,
        isFormFiller: false,
        fieldId: 0,
        fieldName: "",
        isPendingApproval: false,
        isPendingViewer: false,
      },
      options: [
        { value: "", text: "Todos" },
        { value: "true", text: "Sim" },
        { value: "false", text: "Não" },
      ],
    };
  },
  computed:{
    getUrlBackToList() {

      return `../../../profile/all`;
    },
  },
  created() {
    this.hasModules();
  },
  methods: {
    showAlertMesssage() {
      this.$refs.alert.show();
    },
    openFormSetting(permission) {
      if (this.settingsShow) this.settingsShow = true;
      else this.settingsShow = false;
    },
    openNewFormRelease() {
      this.$refs.newFormRelease.openModal();
    },
    getAllFormPermission(ctx, callback) {
      this.isBusy = true;
      console.log(ctx);
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        formName: ctx.filter.formName,
        isFormViewer: ctx.filter.isFormViewer,
        isFormEditor: ctx.filter.isFormEditor,
        isFormFiller: ctx.filter.isFormFiller,
      };
      this.$apiChecklist
        .post("/profileRelease/allFormPermission/" + this.id, apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    getAllFieldPermission(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        formName: ctx.filter.formName,
        fieldName: ctx.filter.fieldName,
        isPendingApproval: ctx.filter.isPendingApproval,
        isPendingViewer: ctx.filter.isPendingViewer,
      };
      this.$apiChecklist
        .post("/profileRelease/allFieldPermission/" + this.id, apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableFieldRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    hasModules() {
      this.$apiScheduler.get("/module/companyHasModule/").then((response) => {
        this.companyHasModules = response.data;
      });
    },
    getAllModulePermission(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        moduleName: ctx.filter.moduleName,
        hasAccess: ctx.filter.hasAccess,
      };
      this.$apiScheduler
        .post("/profileReleas/getAllModulePermission/" + this.id, apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableModuleRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    refreshTableF() {
      this.$refs.tableForm.refresh();
      this.refreshTableForm = false;
    },
    refreshTableC() {
      this.$refs.tableChecklist.refresh();
      this.refreshTableChecklist = false;
    },
  },
  watch: {
    refreshTableForm() {
      if (this.refreshTableForm) this.refreshTableF();
    },
    refreshTableChecklist() {
      if (this.refreshTableChecklist) this.refreshTableC();
    },
  },
};
</script>
